// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"BackDrop__Backdrop__1I6Gb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/backdrop/BackDrop.css
// module id = 82
// module chunks = 3